import { getCookie, setCookie } from "./dom";
var displayShown = false;
var checkModalDisplay = function checkModalDisplay(el, cookieName) {
  displayShown = true;
  el.modal('show');
  setCookie(cookieName, "shown", el.data("save"));
};
var displayModal = function displayModal(modalId, cookieName) {
  var $popup = $("#".concat(modalId));
  if ($popup.length === 0) return;
  var cookieValue = getCookie(cookieName);
  if (cookieValue === "shown") return;
  var delay = $popup.data("delay") == 0 ? 1 : parseInt($popup.data("delay"), 10) * 1000;
  var checkPopupInterval = setInterval(function () {
    if (!displayShown) {
      checkModalDisplay($popup, cookieName, modalId);
    } else {
      clearInterval(checkPopupInterval);
    }
  }, delay);
};
export default displayModal;


// WEBPACK FOOTER //
// ./scripts/util/modal.js